import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { handleGlobalSearch } from '@/utils';
import { PaginatedResponse, Patient, TreatmentCourse, TreatmentCourseFormData, TreatmentCoursesResponse } from '@/utils/types';
import { UUID } from 'crypto';

export const treatmentCoursesApi = createApi({
    reducerPath: 'treatmentCoursesApi',
    tagTypes: ['treatmentCourses'],
    baseQuery: baseQuery,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        addTreatmentCourse: builder.mutation({
            query: (data: TreatmentCourseFormData) => ({
                url: `treatment-course`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['treatmentCourses'],
        }),

        updateTreatmentCourse: builder.mutation({
            query: ({ id, data, }: { id: UUID | string, data: TreatmentCourseFormData }) => ({
                url: `treatment-course/${id}`,
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: ['treatmentCourses'],
        }),


        deleteTreatmentCourse: builder.mutation({
            query: (id: UUID | string) => ({
                url: `treatment-course/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['treatmentCourses'],
        }),

        getTreatmentCourses: builder.query<PaginatedResponse<TreatmentCoursesResponse>, any>({
            query: ({ page, filters }: { page: number; filters: any }) => ({
                url: `treatment-course`,
                params: { page, ...handleGlobalSearch(filters, ['email']) },
            }),
            providesTags: ['treatmentCourses'],
        }),

        getTreatmentCourseMetaDataById: builder.query({
            query: (id: UUID) => ({
                url: `treatment-course/${id}/metadata`,
            }),
            providesTags: ['treatmentCourses'],
        }),

        getTreatmentCourseById: builder.query<TreatmentCourse, any>({
            query: (id: UUID) => ({
                url: `treatment-course/${id}`,
            }),
            providesTags: ['treatmentCourses'],
        }),

        confirmTreatmentCourse: builder.mutation({
            query: ({ id, data, }: { id: UUID | string, data: Partial<Patient & { sign: string }> }) => ({
                url: `treatment-course/${id}/confirm`,
                method: 'PATCH',
                body: data,
            }),
        }),


    }),
});

export const {
    useGetTreatmentCoursesQuery,
    useAddTreatmentCourseMutation,
    useDeleteTreatmentCourseMutation,
    useGetTreatmentCourseMetaDataByIdQuery,
    useUpdateTreatmentCourseMutation,
    useGetTreatmentCourseByIdQuery,
    useConfirmTreatmentCourseMutation
} = treatmentCoursesApi;
